import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, IExclusionOrder } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { Box } from '@chakra-ui/react';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';

function VisaPrepAdditionalHistoryStep4Info(props: IVisaPrepForm) {
  const renderExclusionOrders = () => {
    const allExclusionsOrders: React.ReactNode[] = [];
    if (props.exclusionOrders && props.exclusionOrders.length) {
      props.exclusionOrders.forEach((exclusion: IExclusionOrder, i: number) => {
        allExclusionsOrders.push(
          <SummaryGroup title={`Exclusion order ${i + 1}`} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.EXCLUSION_DATE}-${i}`}
              label="Date of Exclusion"
              value={exclusion.exclusionDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.EXCLUSION_REASON}-${i}`}
              value={exclusion.reason}
              label="Reason for exclusion"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.EXCLUSION_REFERENCE}-${i}`}
              value={exclusion.reference}
              label="Reference number"
            />
          </SummaryGroup>,
        );
      });
    }
    return allExclusionsOrders;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_BEEN_TO_UK}
        label={'Have you ever been to the UK?'}
        value={boolToYesNo(props.hasBeenToUk)}
      />
      {props.hasBeenToUk ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.HAS_NI_NUMBER}
            label={'Do you have a UK National Insurance Number?'}
            value={boolToYesNo(props.hasNINumber)}
          />
          {props.hasNINumber && (
            <SummaryRow
              className={'visa-summary'}
              key={VQ.NI_NUMBER}
              value={props.niNumber}
              label={'What is the number?'}
            />
          )}
          <SummaryRow
            className={'visa-summary'}
            key={VQ.HAS_RECEIVED_MEDICAL_TREATMENT}
            label={'Have you ever received medical treatment in the UK?'}
            value={boolToYesNo(props.hasReceivedMedicalTreatment)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.HAS_VOLUNTARILY_DEPARTED}
            label={'Have you ever voluntarily elected to depart the UK?'}
            value={boolToYesNo(props.hasVoluntarilyDeparted)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.HAS_EXCLUSION_ORDER}
            label={'Have you received, or have you been subject to, an exclusion order from the UK?'}
            value={boolToYesNo(props.hasExclusionOrder)}
          />
          {props.hasExclusionOrder && (
            <>
              <SummaryRow
                className={'visa-summary'}
                label="How many exclusion orders?"
                value={props.exclusionOrders?.length ?? 0}
              />

              <Box as="ol" pl={8}>
                {renderExclusionOrders()}
              </Box>
            </>
          )}
        </>
      ) : null}
    </>
  );
}

export default VisaPrepAdditionalHistoryStep4Info;
